import { Image, Switch, Table, Tag, Typography } from "antd";
import { getPhotoUrl, priceToCurrency } from "utils/common";

const { Paragraph } = Typography;

function TopRestaurant(props) {
  const { dataSource, isLoading } = props;

  const columns = [
    {
      title: "STT",
      align: "center",
      width: "5%",
      render: (text, record, index) => index + 1,
    },
    {
      title: "Hình ảnh",
      width: "10%",
      dataIndex: ["info", "avatar"],
      render: (avatar) =>
        avatar ? (
          <Image
            alt="Avatar of restaurant"
            src={getPhotoUrl(avatar?.path || null)}
            width="80px"
            height="80px"
          />
        ) : null,
    },
    {
      title: "Tên quán",
      width: "24%",
      // dataIndex: "name",
      render: (record) => (
        <>
          <b style={{ display: "block" }}>{record.info.name}</b>
          {record.info.isPartner ? (
            <Tag
              color="blue"
              style={{ display: "inline-block", marginTop: "4px" }}
            >
              Đối tác
            </Tag>
          ) : null}
          {record.info.isNew ? (
            <Tag
              color="green"
              style={{ display: "inline-block", marginTop: "4px" }}
            >
              Quán mới
            </Tag>
          ) : null}
          {record.info.isHot ? (
            <Tag
              color="orange"
              style={{ display: "inline-block", marginTop: "4px" }}
            >
              Nổi bật
            </Tag>
          ) : null}
        </>
      ),
    },
    {
      title: "Địa chỉ",
      dataIndex: ["info", "address"],
      width: "20%",
      render: (address) => (
        <Paragraph ellipsis={{ rows: 2, tooltip: address }}>
          {address}
        </Paragraph>
      ),
    },
    {
      title: "Tổng đơn",
      width: "10%",
      align: "center",
      render: (record) => record.totalOrders,
    },
    {
      title: "Số dư ví",
      width: "8%",
      render: (record) => priceToCurrency(record.info.balance ?? 0),
    },
    {
      title: "Chiết khấu",
      width: "10%",
      align: "center",
      render: (record) =>
        record.info.chargeMode === "default" ? (
          <Tag color="geekblue">Mặc định</Tag>
        ) : (
          <Tag color="orange">{record.info.charge}%</Tag>
        ),
    },
    {
      title: "Có voucher",
      align: "center",
      width: "10%",
      render: (record) => (
        <Switch size="default" checked={record.info.isPromo} />
      ),
    },
    {
      title: "Đang mở",
      // dataIndex: "isOpen",
      align: "center",
      width: "10%",
      render: (record) => (
        <Switch size="default" checked={record.info.isOpen} />
      ),
    },
    {
      title: "Trạng thái",
      dataIndex: ["info", "active"],
      align: "center",
      width: "10%",
      render: (active) =>
        active ? (
          <Tag color="#4caf50">Active</Tag>
        ) : (
          <Tag color="#f44336">In-active</Tag>
        ),
    },
  ];

  return (
    <Table
      bordered
      loading={isLoading}
      columns={columns}
      dataSource={dataSource}
      rowKey={(record) => record.info._id}
      pagination={false}
    />
  );
}

export default TopRestaurant;
